<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_custCode') || '下单客户'"
            prop="custCode"
          >
            <dict-select
              clearable
              v-model="formData.custCode"
              :selectedLabel.sync="formData.custName"
              filterable
              size="mini"
              url="/master/common/dict/customerSelect"
              style="width:100%"
              :placeholder="$l('form_label_pl_custCode') || '请选择下单客户'"
              @change="custChange"
              :disabled="!!orderTechPricingCode"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_custOrderNo') || '客户订单号'"
            prop="custOrderNo"
          >
            <el-input
              v-model="formData.custOrderNo"
              readonly
              :disabled="!!orderTechPricingCode"
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="openChooseNotic"
                :disabled="!!orderTechPricingCode"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_factoryOrderNo') || '工厂订单号'"
            prop="factoryOrderNo"
          >
            <el-input
              v-model="formData.factoryOrderNo"
              :placeholder="
                $l('form_label_pl_custOrderNo') || '请选择客户订单号'
              "
              :maxlength="500"
              clearable
              readonly
              :disabled="!!orderTechPricingCode"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_reviewTime') || '生效日期'">
            <el-date-picker
              v-model="formData.reviewTime"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_productName') || '产品名称'"
            prop="productName"
          >
            <el-input
              v-model="formData.productName"
              :placeholder="$l('form_label_pl_productName') || '请输入产品名称'"
              :maxlength="500"
              clearable
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_categoryCode') || '产品分类'"
            prop="categoryCode"
          >
            <category-cascader
              :detailCategoryCode.sync="formData.categoryCode"
              :masterCategoryCode.sync="formData.masterCategoryCode"
              :categoryFullName.sync="formData.categoryFullName"
              :params="{ parentCode: 'ABSHome', isEcom: 'N' }"
              clearable
              size="mini"
              :disabled="disabled"
              :placeholder="
                $l('form_label_pl_categoryCode') || '请选择产品分类'
              "
            ></category-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_authorBy') || '编制人员'"
            prop="authorBy"
          >
            <dict-select
              v-model="formData.authorBy"
              :selectedLabel.sync="formData.authorByName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('form_label_pl_authorBy') || '请选择编制人员'"
              filterable
              clearable
              :disabled="disabled"
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_reviewBy') || '审核人员'"
            prop="reviewBy"
          >
            <dict-select
              v-model="formData.reviewBy"
              :selectedLabel.sync="formData.reviewByName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="''"
              filterable
              clearable
              disabled
              size="mini"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="mt-3">
        <el-col :span="24">
          <GoodsSpec
            ref="goodsSpec"
            :detailList="formData.detailList"
            :orderTechPricingCode="formData.orderTechPricingCode"
            :orderCode="formData.orderCode"
            :disabled="disabled"
            :auditDisabled="auditDisabled"
            @reload="getData"
          ></GoodsSpec>
        </el-col>
      </el-row>
    </el-form>

    <chooseNoticeOrder
      :visible.sync="chooseVisible"
      :title="$l('form_label_choose_notice_order') || '选择生产订单通知书'"
      @confirm="chooseConfirm"
      :custCode="formData.custCode"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import chooseNoticeOrder from '../choose-notice-order'
import GoodsSpec from '../goods-spec'

export default {
  mixins: [EditLoading],
  components: { chooseNoticeOrder, GoodsSpec },
  props: {
    disabled: { type: Boolean, default: true },
    auditDisabled: { type: Boolean, default: true },
    orderTechPricingCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { authorBy: '', authorByName: '' },
      chooseVisible: false,
      rules: {
        productName: [
          {
            required: true,
            message: this.$l('form_label_pl_productName') || '请输入产品名称',
            trigger: 'change',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('form_label_pl_custCode') || '请选择下单客户',
            trigger: 'change',
          },
        ],
        custOrderNo: [
          {
            required: true,
            message: this.$l('form_label_pl_custOrderNo') || '请选择客户订单号',
            trigger: 'change',
          },
        ],

        factoryOrderNo: [
          {
            required: true,
            message: this.$l('form_label_pl_custOrderNo') || '请选择客户订单号',
            trigger: 'change',
          },
        ],
        categoryCode: [
          {
            required: true,
            message: this.$l('form_label_pl_categoryCode') || '请选择产品分类',
            trigger: 'change',
          },
        ],
        authorBy: [
          {
            required: true,
            message: this.$l('form_label_pl_authorBy') || '请选择编制人员',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
  },
  watch: {
    userInfo: {
      handler() {
        if (this.orderTechPricingCode) return
        if (!this.userInfo) return
        const { userCode, userName, userNameEn } = this.userInfo
        this.formData.authorBy = userCode || ''
        this.formData.authorByName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.orderTechPricingCode) return
      this.formData.detailList = []
      const data = await this.$api
        .orderTechPricingDetailApi({
          orderTechPricingCode: this.orderTechPricingCode,
        })
        .then((res) => res.body || {})
        .catch(() => ({}))
      this.formData = { ...data }
      this.$emit('loaded', data)
    },
    openChooseNotic() {
      const { custCode } = this.formData
      if (!custCode) {
        this.$message({
          message: this.$l('form_label_first_custCode') || '请先选择下单客户',
          type: 'warning',
        })
        return
      }
      this.chooseVisible = true
    },
    chooseConfirm(e) {
      if (!e) return
      const {
        orderCode = '',
        noticeOrderCode = '',
        custOrderNo = '',
        factoryOrderNo = '',
      } = e
      this.formData = {
        ...this.formData,
        orderCode,
        noticeOrderCode,
        custOrderNo,
        factoryOrderNo,
      }
    },

    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (!this.orderTechPricingCode) {
        const confirm = await this.$confirm(
          this.$l('tip_save_info') ||
            '保存后[下单客户][客户订单号][工厂订单号]无法修改，是否继续保存？',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
          }
        )
          .then(() => true)
          .catch(() => false)
        if (!confirm) return
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .orderTechPricingSaveApi({
          ...this.formData,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.orderTechPricingCode) return this.getData()

      const { orderTechPricingCode, orderTechPricingNo } = body
      this.$router.replace({
        name: 'production-orderTechPricing-detail',
        params: { code: orderTechPricingCode, pageType: 'edit' },
        query: { orderTechPricingNo },
      })
    },
    async custChange() {
      this.initCust()
    },
    initCust() {
      if (!this.formData.custOrderNo) return
      this.formData.orderCode = ''
      this.formData.noticeOrderCode = ''
      this.formData.custOrderNo = ''
      this.formData.factoryOrderNo = ''
    },
  },
}
</script>
<style lang="scss" scoped>
.packing-form {
  background-color: #f4f6f9;
  padding: 16px;
  padding-bottom: 6px;
  border-radius: 5px;
  margin-bottom: 16px;
  .tool-btn {
    font-size: 22px;
  }
}
::v-deep {
  .packing-form {
    .el-input.is-disabled .el-input__inner,
    .el-textarea.is-disabled .el-textarea__inner {
      color: #606266 !important;
      background-color: #fff !important;
      border: 1px solid #dcdfe6 !important;
    }
  }
}
</style>
